export default __webpack_public_path__ + "static/media/MR1.daca6c92.jpg";